import React, { createContext, useCallback, useContext, useState } from "react";
import ScheduleCallModal from "../components/ScheduleCallModal";

const ScheduleCallContext = createContext(null);

export const ScheduleCallProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openScheduleCall = useCallback(() => setIsOpen(true), []);
  const closeScheduleCall = useCallback(() => setIsOpen(false), []);

  return (
    <ScheduleCallContext.Provider
      value={{ isOpen, openScheduleCall, closeScheduleCall }}
    >
      {children}
      <ScheduleCallModal isOpen={isOpen} onClose={closeScheduleCall} />
    </ScheduleCallContext.Provider>
  );
};

export const useScheduleCall = () => {
  const context = useContext(ScheduleCallContext);
  if (!context) {
    throw new Error("useScheduleCall must be used within ScheduleCallProvider");
  }
  return context;
};
